export default "__VITE_ASSET__8f136272__"